
import { curry2, equals, Exception, comparePrimitives, round } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { SvgHelper_createSvgElement } from "../../fable_modules/Feliz.3.1.1/Svg.fs.js";
import { empty, reverse, cons, mapFold, map, max, tail as tail_3, head, isEmpty, ofSeq, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/List.js";
import { join, replace, printf, toText } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/String.js";
import { toString, Union, Record } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Types.js";
import { union_type, list_type, string_type, char_type, bool_type, record_type, float64_type } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Reflection.js";
import { isLetter, isDigit } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Char.js";
import { FSharpChoice$3 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Choice.js";
import { collect, empty as empty_1, singleton as singleton_1, append, delay, map as map_1, toList } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Seq.js";
import { max as max_1 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Double.js";
import { List_intersperse } from "../../Domain/Basics.jsx";
import { createElement, memo } from "react";
import React from "react";
import { StringBuilder__Append_244C7CD6, StringBuilder_$ctor, StringBuilder__get_Length } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/System.Text.js";
import { some, unwrap, value as value_19 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Option.js";
import { nonSeeded } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Random.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Range.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Util.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.1.1/Html.fs.js";
import { op_UnaryNegation_Int32 } from "../../fable_modules/fable-library-js.5.0.0-alpha.22/Int32.js";
import "../../../components/custom/MathSvg.css";

export function round4(value) {
    return round(value, 4);
}

const gridPaperPatternDefinition = SvgHelper_createSvgElement("pattern", ofArray([["id", "grid"], ["className", "grid-pattern"], ["width", 1], ["height", 1], ["patternUnits", "userSpaceOnUse"], ["children", singleton(SvgHelper_createSvgElement("rect", ofArray([["width", 1], ["height", 1]])))]]));

const markerDefinition = SvgHelper_createSvgElement("marker", ofArray([["id", "arrowhead"], ["className", "arrowhead"], ["markerWidth", "4"], ["markerHeight", "4"], ["refX", "3"], ["refY", "2"], ["orient", "auto"], ["children", singleton(SvgHelper_createSvgElement("polygon", singleton(["points", "0 0, 4 2, 0 4"])))]]));

function renderCurvedArrow(startX, startY, endX, endY, curvature) {
    const controlY = startY + curvature;
    const controlX = (startX + endX) / 2;
    return SvgHelper_createSvgElement("path", ofArray([["className", "curved-arrow"], ["d", toText(printf("M %.2f,%.2f Q %.2f,%.2f %.2f,%.2f"))(startX)(startY)(controlX)(controlY)(endX)(endY)], ["strokeWidth", 0.08], ["markerEnd", "url(#arrowhead)"]]));
}

function renderDebugRect(x, y, width, height) {
    return SvgHelper_createSvgElement("rect", ofArray([["className", "debug-box"], ["x", x], ["y", y], ["width", width], ["height", height]]));
}

export class Size extends Record {
    constructor(Width, Height) {
        super();
        this.Width = Width;
        this.Height = Height;
    }
}

export function Size_$reflection() {
    return record_type("MatheApp.UI.Components.MathSvg.Size", [], Size, () => [["Width", float64_type], ["Height", float64_type]]);
}

export function Size_op_Multiply_2A8A951D(size, factor) {
    return new Size(size.Width * factor, size.Height * factor);
}

export function Size_get_Zero() {
    return new Size(0, 0);
}

export function Size_get_Unit() {
    return new Size(1, 1);
}

export function Size_Create_7B00E9A0(width, height) {
    return new Size(width, height);
}

export class Scale extends Record {
    constructor(X, Y, Text$) {
        super();
        this.X = X;
        this.Y = Y;
        this.Text = Text$;
    }
}

export function Scale_$reflection() {
    return record_type("MatheApp.UI.Components.MathSvg.Scale", [], Scale, () => [["X", float64_type], ["Y", float64_type], ["Text", float64_type]]);
}

export function Scale_get_Unit() {
    return new Scale(1, 1, 1);
}

export function Scale_Create_Z7AD9E565(x, y, text) {
    return new Scale(x, y, text);
}

export class Position extends Record {
    constructor(X, Y) {
        super();
        this.X = X;
        this.Y = Y;
    }
}

export function Position_$reflection() {
    return record_type("MatheApp.UI.Components.MathSvg.Position", [], Position, () => [["X", float64_type], ["Y", float64_type]]);
}

export function Position_get_Zero() {
    return new Position(0, 0);
}

export function Position_Create_7B00E9A0(x, y) {
    return new Position(x, y);
}

export function Position_CreateX_5E38073B(x) {
    return new Position(x, 0);
}

export function Position_CreateY_5E38073B(y) {
    return new Position(0, y);
}

export class MathLayoutItem extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "Space", "Digit", "Unit", "Comma", "Separator", "EqualsSign", "CurvedArrow", "FractionLine", "Editor", "Group"];
    }
}

export function MathLayoutItem_$reflection() {
    return union_type("MatheApp.UI.Components.MathSvg.MathLayoutItem", [], MathLayoutItem, () => [[], [["Item1", float64_type], ["snap", bool_type]], [["Item", char_type]], [["Item", string_type]], [], [], [], [["Item", bool_type]], [], [["isValid", bool_type]], [["children", list_type(MathLayout_$reflection())], ["className", string_type]]]);
}

export class MathLayout extends Record {
    constructor(Item, Size, Position, Scale) {
        super();
        this.Item = Item;
        this.Size = Size;
        this.Position = Position;
        this.Scale = Scale;
    }
}

export function MathLayout_$reflection() {
    return record_type("MatheApp.UI.Components.MathSvg.MathLayout", [], MathLayout, () => [["Item", MathLayoutItem_$reflection()], ["Size", Size_$reflection()], ["Position", Position_$reflection()], ["Scale", Scale_$reflection()]]);
}

export function group(className, children) {
    return new MathLayoutItem(10, [children, className]);
}

export function right(_arg) {
    return _arg.Position.X + _arg.Size.Width;
}

export function bottom(_arg) {
    return _arg.Position.Y + _arg.Size.Height;
}

export function center(outerSize, innerSize) {
    return (outerSize - innerSize) / 2;
}

export const emptyLayout = (() => {
    const Position_1 = Position_get_Zero();
    return new MathLayout(new MathLayoutItem(0, []), Size_get_Zero(), Position_1, Scale_get_Unit());
})();

function $007CLetterChar$007CDigitChar$007CDachChar$007C(_arg) {
    if (isDigit(_arg)) {
        return new FSharpChoice$3(1, [_arg]);
    }
    else if (_arg === "^") {
        return new FSharpChoice$3(2, [undefined]);
    }
    else {
        return new FSharpChoice$3(0, [_arg]);
    }
}

export function measure(scale, item) {
    let matchValue, activePatternResult_1;
    switch (item.tag) {
        case 0:
            return Size_get_Zero();
        case 1:
            return Size_Create_7B00E9A0(item.fields[0] * scale.X, scale.Y);
        case 2:
            return Size_Create_7B00E9A0(scale.X, scale.Y);
        case 4:
            return Size_get_Zero();
        case 5:
            return Size_get_Zero();
        case 6:
            return Size_get_Unit();
        case 3: {
            const u = item.fields[0];
            return Size_Create_7B00E9A0(scale.X * ((matchValue = ofSeq(u.split("")), !isEmpty(matchValue) ? (($007CLetterChar$007CDigitChar$007CDachChar$007C(head(matchValue)).tag === 0) ? (!isEmpty(tail_3(matchValue)) ? ((activePatternResult_1 = $007CLetterChar$007CDigitChar$007CDachChar$007C(head(tail_3(matchValue))), (activePatternResult_1.tag === 0) ? (!isEmpty(tail_3(tail_3(matchValue))) ? (($007CLetterChar$007CDigitChar$007CDachChar$007C(head(tail_3(tail_3(matchValue)))).tag === 2) ? (!isEmpty(tail_3(tail_3(tail_3(matchValue)))) ? (($007CLetterChar$007CDigitChar$007CDachChar$007C(head(tail_3(tail_3(tail_3(matchValue))))).tag === 1) ? (isEmpty(tail_3(tail_3(tail_3(tail_3(matchValue))))) ? 2 : u.length) : u.length) : u.length) : u.length) : 1) : ((activePatternResult_1.tag === 2) ? (!isEmpty(tail_3(tail_3(matchValue))) ? (($007CLetterChar$007CDigitChar$007CDachChar$007C(head(tail_3(tail_3(matchValue)))).tag === 1) ? (isEmpty(tail_3(tail_3(tail_3(matchValue)))) ? 1 : u.length) : u.length) : u.length) : u.length))) : 1) : u.length) : 0)), scale.Y);
        }
        case 10: {
            const children = item.fields[0];
            return Size_Create_7B00E9A0(max(map(right, children), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            }), max(map(bottom, children), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
        }
        default:
            throw new Exception(`Cannot measure item of type '${item}'`);
    }
}

export class StackDirection extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Horizontal", "Vertical"];
    }
}

export function StackDirection_$reflection() {
    return union_type("MatheApp.UI.Components.MathSvg.StackDirection", [], StackDirection, () => [[], []]);
}

export function arrangeStack(scale, direction, items) {
    const dirScale = equals(direction, new StackDirection(0, [])) ? scale.X : scale.Y;
    return mapFold((offset_1, item) => {
        let rounded;
        const size = measure(scale, item);
        const layout = new MathLayout(item, size, equals(direction, new StackDirection(0, [])) ? Position_CreateX_5E38073B(offset_1) : Position_CreateY_5E38073B(offset_1), scale);
        const newOffset = equals(direction, new StackDirection(0, [])) ? (offset_1 + size.Width) : (offset_1 + size.Height);
        return [layout, (item.tag === 1) ? (item.fields[1] ? ((rounded = round(newOffset / dirScale), Math.ceil(rounded) * dirScale)) : newOffset) : ((rounded = round(newOffset / dirScale), Math.ceil(rounded) * dirScale))];
    }, 0, items)[0];
}

export function arrangeNumber(scale, text) {
    return group("number", arrangeStack(scale, new StackDirection(0, []), toList(map_1((c) => {
        let x;
        if ((x = c, ("0" <= x) && (x <= "9"))) {
            return new MathLayoutItem(2, [c]);
        }
        else {
            switch (c) {
                case ",":
                    return new MathLayoutItem(4, []);
                case ".":
                    return new MathLayoutItem(5, []);
                default:
                    throw new Exception("Unsupported character in number");
            }
        }
    }, text.split("")))));
}

export function arrangeFraction(arrange_1, scale, numerator, denominator) {
    let Position_2;
    const fractionScale = equals(scale, Scale_get_Unit()) ? (new Scale(0.5, 0.9, 0.7)) : (new Scale(scale.X * 0.5, scale.Y * 0.6, scale.Text));
    const numLayout = arrange_1(fractionScale, numerator);
    const denomLayout = arrange_1(fractionScale, denominator);
    const numSize = measure(fractionScale, numLayout);
    const numWidth = numSize.Width;
    const denomSize = measure(fractionScale, denomLayout);
    const denomWidth = denomSize.Width;
    let width;
    const value = max_1(max_1(numWidth, denomWidth), 1);
    width = Math.ceil(value);
    const centerX = (innerSize) => center(width, innerSize);
    const numY = (1 - numSize.Height) - 0.45;
    return group("fraction", ofArray([new MathLayout(numLayout, numSize, Position_Create_7B00E9A0(centerX(numWidth), numY), fractionScale), (Position_2 = Position_CreateY_5E38073B(0.5), new MathLayout(new MathLayoutItem(8, []), Size_Create_7B00E9A0(width, 0), Position_2, Scale_get_Unit())), new MathLayout(denomLayout, denomSize, Position_Create_7B00E9A0(centerX(denomWidth), 0.45), fractionScale)]));
}

export function arrangeEquals(arrange_1, scale, l, r) {
    return group("equals-exp", arrangeStack(scale, new StackDirection(0, []), ofArray([arrange_1(scale, l), new MathLayoutItem(6, []), arrange_1(scale, r)])));
}

export function arrangeEqualsFactor(arrange_1, scale, l, f, r) {
    let Position_1;
    const offsetY = (offset, height) => ((1 + offset) - height);
    const arrowSize = Size_Create_7B00E9A0(1.5, 0.2);
    const arrowX = center(2, arrowSize.Width);
    const factorScale = new Scale(0.4, 0.6, 0.9);
    const factor = arrange_1(factorScale, f);
    const factorSize = measure(factorScale, factor);
    const factorX = center(2, factorSize.Width);
    const equalsGroup = group("equals-factor", ofArray([(Position_1 = Position_CreateX_5E38073B(0.5), new MathLayout(new MathLayoutItem(6, []), Size_get_Unit(), Position_1, Scale_get_Unit())), new MathLayout(factor, factorSize, Position_Create_7B00E9A0(factorX, -0.8), factorScale), new MathLayout(factor, factorSize, Position_Create_7B00E9A0(factorX, offsetY(0.8, factorSize.Height)), factorScale), new MathLayout(new MathLayoutItem(7, [true]), arrowSize, Position_Create_7B00E9A0(arrowX, -0.1), Scale_get_Unit()), new MathLayout(new MathLayoutItem(7, [false]), arrowSize, Position_Create_7B00E9A0(arrowX, offsetY(0.1, arrowSize.Height)), Scale_get_Unit())]));
    return group("equals-exp", arrangeStack(scale, new StackDirection(0, []), ofArray([arrange_1(scale, l), equalsGroup, arrange_1(scale, r)])));
}

export function arrangeUnit(arrange_1, scale, value, unit) {
    const unit_1 = replace(replace(unit, "²", "^2"), "³", "^3");
    const needsSpace = (unit_1.length > 0) && isLetter(unit_1[0]);
    const child = arrange_1(scale, value);
    return group("unit-exp", arrangeStack(scale, new StackDirection(0, []), toList(delay(() => append(singleton_1(child), delay(() => append(needsSpace ? singleton_1(new MathLayoutItem(1, [0.5, false])) : singleton_1(new MathLayoutItem(0, [])), delay(() => singleton_1(new MathLayoutItem(3, [unit_1]))))))))));
}

export function arrangeEditor(arrange_1, scale, inner, isValid) {
    const innerLayout = arrange_1(scale, inner);
    const innerSize = measure(scale, innerLayout);
    const minSize = Size_Create_7B00E9A0(scale.X, scale.Y);
    return group(isValid ? "editor" : "editor invalid", ofArray([new MathLayout(new MathLayoutItem(9, [isValid]), new Size(max_1(innerSize.Width, minSize.Width), max_1(innerSize.Height, minSize.Height)), Position_get_Zero(), Scale_get_Unit()), new MathLayout(innerLayout, innerSize, Position_get_Zero(), scale)]));
}

export function arrangeList(arrange_1, scale, items) {
    return group("list", arrangeStack(scale, new StackDirection(1, []), List_intersperse(new MathLayoutItem(1, [1, true]), map(curry2(arrange_1)(scale), items))));
}

export function arrange(scale, ausdruck) {
    switch (ausdruck.tag) {
        case 0:
            return new MathLayoutItem(0, []);
        case 2:
            return arrangeNumber(scale, ausdruck.fields[0]);
        case 6:
            return arrangeEquals(arrange, scale, ausdruck.fields[0], ausdruck.fields[1]);
        case 3:
            return arrangeFraction(arrange, scale, ausdruck.fields[0], ausdruck.fields[1]);
        case 8:
            return arrangeUnit(arrange, scale, ausdruck.fields[0], ausdruck.fields[1]);
        case 7:
            return arrangeEqualsFactor(arrange, scale, ausdruck.fields[0], ausdruck.fields[1], ausdruck.fields[2]);
        case 4:
            return arrangeEditor(arrange, scale, ausdruck.fields[0], true);
        case 5:
            return arrangeEditor(arrange, scale, ausdruck.fields[0], false);
        case 9:
            return arrangeList(arrange, scale, ausdruck.fields[0]);
        default:
            throw new Exception(`Cannot arrange Ausdruck of type '${ausdruck}'`);
    }
}

export function setScale(x, y, text) {
    return ["style", {
        "--text-scale": text,
        "--x-scale": x,
        "--y-scale": y,
    }];
}

export function MathText($props) {
    const scaleToSet = $props.scaleToSet;
    const text = $props.text;
    const className = $props.className;
    const position = $props.position;
    const y = position.Y;
    const x = position.X;
    let children;
    if ((text.length > 1) && (text.indexOf("^") >= 0)) {
        const apply = (sb, result) => {
            if (StringBuilder__get_Length(sb) > 0) {
                return cons(SvgHelper_createSvgElement("tspan", singleton(["children", singleton(toString(sb))])), result);
            }
            else {
                return result;
            }
        };
        const buildTspans = (rest_mut, sb_1_mut, result_1_mut) => {
            buildTspans:
            while (true) {
                const rest = rest_mut, sb_1 = sb_1_mut, result_1 = result_1_mut;
                let matchResult, nextChar_1, tail_1, c, tail_2;
                if (!isEmpty(rest)) {
                    if (head(rest) === "^") {
                        if (!isEmpty(tail_3(rest))) {
                            if (isDigit(head(tail_3(rest)))) {
                                matchResult = 1;
                                nextChar_1 = head(tail_3(rest));
                                tail_1 = tail_3(tail_3(rest));
                            }
                            else {
                                matchResult = 2;
                                c = head(rest);
                                tail_2 = tail_3(rest);
                            }
                        }
                        else {
                            matchResult = 2;
                            c = head(rest);
                            tail_2 = tail_3(rest);
                        }
                    }
                    else {
                        matchResult = 2;
                        c = head(rest);
                        tail_2 = tail_3(rest);
                    }
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return reverse(apply(sb_1, result_1));
                    case 1: {
                        rest_mut = tail_1;
                        sb_1_mut = StringBuilder_$ctor();
                        result_1_mut = cons(SvgHelper_createSvgElement("tspan", ofArray([["className", "super"], ["children", singleton(nextChar_1)]])), apply(sb_1, result_1));
                        continue buildTspans;
                    }
                    default: {
                        StringBuilder__Append_244C7CD6(sb_1, c);
                        rest_mut = tail_2;
                        sb_1_mut = sb_1;
                        result_1_mut = result_1;
                        continue buildTspans;
                    }
                }
                break;
            }
        };
        children = buildTspans(ofSeq(text.split("")), StringBuilder_$ctor(), empty());
    }
    else {
        children = undefined;
    }
    return SvgHelper_createSvgElement("text", toList(delay(() => append(singleton_1(["className", className]), delay(() => append((x !== 0) ? singleton_1(["x", x]) : empty_1(), delay(() => append((y !== 0) ? singleton_1(["y", y]) : empty_1(), delay(() => append((scaleToSet != null) ? singleton_1(setScale(value_19(scaleToSet).X, value_19(scaleToSet).Y, value_19(scaleToSet).Text)) : empty_1(), delay(() => ((children != null) ? singleton_1(["children", value_19(children)]) : singleton_1(["children", singleton(text)])))))))))))));
}

export function makeRandomWobblyLine(startX, startY, endX, endY, amplitude, frequency) {
    const rand = nonSeeded();
    const length = endX - startX;
    return "M " + join(" L ", toList(delay(() => collect((i) => {
        const x = startX + ((i / (length * frequency)) * length);
        const y = startY + (((rand.NextDouble() * 2) - 1) * amplitude);
        return singleton_1(toText(printf("%.2f,%.2f"))(x)(y));
    }, rangeDouble(0, 1, ~~(length * frequency))))));
}

export function MathFractionLine($props) {
    const width = $props.width;
    const position = $props.position;
    const x = position.X;
    if (Math.abs(x - position.Y) < 0.0001) {
        return defaultOf();
    }
    else {
        return SvgHelper_createSvgElement("path", ofArray([["className", "fraction-line"], ["d", makeRandomWobblyLine(x, 0.5, x + width, 0.5, 0.008, 2)], ["fill", "none"]]));
    }
}

export const MathContainer = (memo)(function MathContainer(props) { return (($props) => {
    const scaleToSet = $props.scaleToSet;
    const children = $props.children;
    const className = $props.className;
    const position = $props.position;
    const render_1 = $props.render;
    const x_1 = round4(position.X);
    const y_1 = round4(position.Y);
    return SvgHelper_createSvgElement("g", toList(delay(() => append(((x_1 !== 0) ? true : (y_1 !== 0)) ? singleton_1(["transform", replace(replace(((("translate(" + x_1) + "px,") + y_1) + "px)", "px", ""), "deg", "")]) : empty_1(), delay(() => append(singleton_1(["className", className]), delay(() => append((scaleToSet != null) ? singleton_1(setScale(round4(value_19(scaleToSet).X), round4(value_19(scaleToSet).Y), round4(value_19(scaleToSet).Text))) : empty_1(), delay(() => singleton_1(["children", map(render_1, children)]))))))))));
})(props); }, function equalsButFunctions(x, y) {
    if (x === y) {
        return true;
    }
    else if ((typeof x === 'object' && !x[Symbol.iterator]) && !(y == null)) {
        const keys = Object.keys(x);
        const length = keys.length | 0;
        let i = 0;
        let result = true;
        while ((i < length) && result) {
            const key = keys[i];
            i = ((i + 1) | 0);
            const xValue = x[key];
            result = ((typeof xValue === 'function') ? true : equals(xValue, y[key]));
        }
        return result;
    }
    else {
        return equals(x, y);
    }
});

export function MathCurvedArrow($props) {
    const isUp = $props.isUp;
    const size = $props.size;
    const position = $props.position;
    const x = position.X;
    const height = size.Height;
    const startY = position.Y + (isUp ? height : 0);
    return renderCurvedArrow(x, startY, x + size.Width, startY, (isUp ? -height : height) * 2);
}

export function MathEditor($props) {
    const isValid = $props.isValid;
    const size = $props.size;
    const position = $props.position;
    return SvgHelper_createSvgElement("rect", ofArray([["className", "editor-box"], ["x", position.X - 0.1], ["y", position.Y - 0.1], ["width", size.Width + (2 * 0.1)], ["height", size.Height + (2 * 0.1)]]));
}

export const isDebugEnabled = false;

export function render(previousScale, layout) {
    const scaleToSet = !equals(layout.Scale, previousScale) ? layout.Scale : undefined;
    let result;
    const matchValue = layout.Item;
    result = ((matchValue.tag === 1) ? defaultOf() : ((matchValue.tag === 4) ? createElement(MathText, {
        position: layout.Position,
        className: "comma",
        text: ",",
    }) : ((matchValue.tag === 5) ? createElement(MathText, {
        position: layout.Position,
        className: "separator",
        text: ".",
    }) : ((matchValue.tag === 2) ? createElement(MathText, {
        position: layout.Position,
        className: "digit",
        text: matchValue.fields[0],
    }) : ((matchValue.tag === 6) ? createElement(MathText, {
        position: layout.Position,
        className: "equals",
        text: "=",
    }) : ((matchValue.tag === 8) ? createElement(MathFractionLine, {
        position: layout.Position,
        width: layout.Size.Width,
    }) : ((matchValue.tag === 7) ? createElement(MathCurvedArrow, {
        position: layout.Position,
        size: layout.Size,
        isUp: matchValue.fields[0],
    }) : ((matchValue.tag === 3) ? createElement(MathText, {
        position: layout.Position,
        className: "unit",
        text: matchValue.fields[0],
    }) : ((matchValue.tag === 9) ? createElement(MathEditor, {
        position: layout.Position,
        size: layout.Size,
        isValid: matchValue.fields[0],
    }) : ((matchValue.tag === 10) ? createElement(MathContainer, {
        render: (layout_1) => render(layout.Scale, layout_1),
        position: layout.Position,
        className: matchValue.fields[1],
        children: matchValue.fields[0],
        scaleToSet: unwrap(scaleToSet),
    }) : defaultOf()))))))))));
    if (isDebugEnabled) {
        const children_1 = ofArray([result, renderDebugRect(layout.Position.X, layout.Position.Y, layout.Size.Width, layout.Size.Height)]);
        return createElement("g", defaultOf_1(), ...children_1);
    }
    else {
        return result;
    }
}

export function renderAusdruck$0027(ausdruck) {
    const layout = arrange(Scale_get_Unit(), ausdruck);
    console.log(some(layout));
    const size = measure(Scale_get_Unit(), layout);
    const root = new MathLayout(layout, size, Position_get_Zero(), Scale_get_Unit());
    return [render(Scale_get_Unit(), root), size];
}

/**
 * Top-Level Komponente: Rendert Ausdruck als SVG mit em-Skalierung
 */
export function SvgGrid($props) {
    const showDebug = $props.showDebug;
    const size = $props.size;
    const ausdruck = $props.ausdruck;
    const patternInput = renderAusdruck$0027(ausdruck);
    const childrenSize = patternInput[1];
    let patternInput_2;
    if (size == null) {
        patternInput_2 = [~~childrenSize.Width, ~~childrenSize.Height];
    }
    else {
        const s = size;
        patternInput_2 = [~~s.Width, ~~s.Height];
    }
    const actualWidth = max_1(12, patternInput_2[0] + (2 * 1)) | 0;
    const actualHeight = max_1(5, patternInput_2[1] + (2 * 2)) | 0;
    return HtmlHelper_createElement("div", ofArray([["className", "math-svg container"], ["children", [SvgHelper_createSvgElement("svg", ofArray([["className", "root"], ["viewBox", `${op_UnaryNegation_Int32(1)} ${op_UnaryNegation_Int32(2)} ${actualWidth} ${actualHeight}`], ["width", "100%"], ["children", ofArray([createElement("defs", defaultOf_1(), gridPaperPatternDefinition, markerDefinition), SvgHelper_createSvgElement("rect", ofArray([["x", op_UnaryNegation_Int32(1)], ["y", op_UnaryNegation_Int32(2)], ["width", actualWidth], ["height", actualHeight], ["fill", "url(#grid)"]])), patternInput[0]])]]))]]]));
}

export function fromAusdruck(ausdruck) {
    return createElement(SvgGrid, {
        ausdruck: ausdruck,
        showDebug: false,
    });
}

export function fromAusdruckWithSize(ausdruck, width, height) {
    return createElement(SvgGrid, {
        ausdruck: ausdruck,
        size: Size_Create_7B00E9A0(width, height),
        showDebug: false,
    });
}

